import { render, staticRenderFns } from "./UserAvatarModal.vue?vue&type=template&id=2d484ca1&scoped=true"
import script from "./UserAvatarModal.vue?vue&type=script&lang=js"
export * from "./UserAvatarModal.vue?vue&type=script&lang=js"
import style0 from "./UserAvatarModal.vue?vue&type=style&index=0&id=2d484ca1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d484ca1",
  null
  
)

export default component.exports